var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"trigger":"click","height":"80px","direction":"vertical","autoplay":"","loop":""}},_vm._l((3),function(item){return _c('el-carousel-item',{key:item},[_c('h3',{staticClass:"small"},[_vm._v(_vm._s(item))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }